module.exports = __webpack_public_path__ + "img/bg.5c9dcd79.png";